import * as actionTypes from 'actions/actionTypes'

const initalState = {
  showCompanyChange : false,
  isSentEmailSupport : false,
  isUnsubscribeSuccess : false,
  showErrorMessageUnsubscribe : false,
  isAccountDeleted : false
}


const settingsReducer = (state = initalState, action) => {
  switch(action.type){
    case actionTypes.SETTINGS_SHOW_CHANGE_COMPANY:
      return {
        ...state,
        showCompanyChange : true
      }
    case actionTypes.SETTINGS_CLOSE_CHANGE_COMPANY:
      return{
        ...state,
        showCompanyChange : false
      }
    case actionTypes.SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS:
      return {
        ...state,
        showCompanyChange : false,
        isSentEmailSupport : true
      }
    case actionTypes.SETTINGS_CLOSE_SENT_EMAIL_SUPORT:
      return {
        ...state,
        isSentEmailSupport: false
      }
    case actionTypes.SETTINGS_UNSUBSCRIBE_SUCCESS:
      return {
        ...state,
        isUnsubscribeSuccess : true
      }
    case actionTypes.SETTINGS_SHOW_ERROR_UNSUBSCRIBE:
      return{
        ...state,
        showErrorMessageUnsubscribe : true,
        errorMessageUnsubscribe: action.errorMessageUnsubscribe
      }
    case actionTypes.SETTINGS_CLOSE_ERROR_UNSUBSCRIBE:
      return {
        ...state,
        showErrorMessageUnsubscribe : false
      }
    case actionTypes.SETTINGS_ACCOUNT_DELETED:
      return {
        ...state,
        isAccountDeleted : true
      }
    default:
      return state
  }
}

export default settingsReducer



// WEBPACK FOOTER //
// ./src/store/reducers/settingsReducer.js